<template>
  <div class="homepage-2">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection :data="hero" />
      <FeatureSection :data="features" />
      <DiscoverSection :data="discover" />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/hero'
import FeatureSection from '../components/FeatureSection/feature'
import DiscoverSection from '../components/DiscoverSection/discover'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'PageTurnkeyWeb',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    FeatureSection,
    DiscoverSection,
    FooterSection
  },
  data () {
    return {
      hero: {
        image: 'assets/img/enterprise/games/sword.jpg',
        title: 'Get Real.',
        subtitle: 'Connect your VR back to R.',
        text: 'The SourceSync Games SDK* lets you add quest, event, location or score-based targeted content for your games, and offer in-game items, coins, buffs or rewards, letting you earn more in a few days of play than you would from selling your game outright.',
        bottomText: '* Available for Unity, Unreal Engine, Phaser and JavaScript in Q1 2022.'
      },
      features: {
        header: 'Bring your games into reality',
        features: [          
          {
            icon: 'flaticon-tap',
            title: 'Tappable actions',
            text: 'Smart Content that can be tapped and interacted with.'
          },
          {
            icon: 'flaticon-fingerprint',
            title: 'More engagement',
            text: 'Import player preferences, behaviors and things they care about.'
          },
          {
            icon: 'flaticon-notification',
            title: 'Programmatic display',
            text: 'Show smart content based on quests, events, locations, scores and more.'
          },
          {
            icon: 'flaticon-place',
            title: 'Augment real locations',
            text: 'Add location-based content like weather and time of day without effort.'
          },
          {
            icon: 'flaticon-settings',
            title: 'Unlimited possibilities',
            text: 'Hundreds of settings, themes and events to choose from'
          },
          {
            icon: 'flaticon-language',
            title: 'Realtime',
            text: 'Offer in-game chat, networking and other features in minutes.'
          }
        ]
      },
      discover: {
        image: 'assets/img/enterprise/games/unreal.jpg',
        title: 'Integrate using powerful tools.',
        subtitle: 'Set areas of effect, triggers and events within you games to trigger smart content.',
        features: [
          'Set areas of effect using shapes in your favorite tools.',
          'Link areas directly to specific content, random or programmatic based on rules.',
          'Link activity within content back to your game.',
          'Automate deals based on IAB categories in your worlds and locations.',
          'Let your players sponsor you by creating NFTs linked to in-game items or content.',
          'Connect NFTs to real-world items like game items, characters, art and other merchandise in the real-world.'
        ]
      }
    }
  }
}
</script>

<style>

</style>